module.exports = require('keen-core/lib/utils/base64');



//////////////////
// WEBPACK FOOTER
// ./~/keen-tracking/lib/utils/base64.js
// module id = 1966
// module chunks = 0